const Dict = (word) => {
  const fa = {
    'enable': 'فعال',
    'role': 'نقش',
    'disable': 'غیرفعال',
    'title': 'عنوان',
    'status': 'وضعیت',
    'unread': 'خوانده نشده',
    'read': 'خوانده شده',
    'description': 'توضیحات',
    'name': 'نام',
    'family': 'نام خانوادگی',
    'profile_photo': 'تصویر پروفایل',
    'father_name': 'نام‌پدر',
    'national_code': 'کدملی',
    'birth_date': 'تاریخ‌تولد',
    'gender': 'جنسیت',
    'home_phone': 'شماره ثابت',
    'province': 'استان',
    "province_title": 'نام استان',
    "province_description": 'نام تکمیلی',
    'tel_prefix': 'پیش‌شماره',
    'order_by': 'اولویت',
    'city': 'شهر',
    'email': 'ایمیل',
    'address': 'آدرس',
    'degree': 'مدرک‌تحصیلی',
    'stage_degree': 'مقطع‌تحصیلی',
    'experience': 'سابقه فعالیت (سال)',
    'field': 'رشته‌فعالیت‌در‌مباشر',
    'branch': 'موضوع ‌فعالیت‌در‌مباشر',
    'select_branch': 'گرایش مشاوره',
    'branch_title': 'گرایش خدمات',
    'speciality': 'حوزه‌تخصصی',
    'about_me': 'درباره‌من',
    'degree_file': 'بارگزاری‌مدرک‌تحصیلی',
    'resume_file': 'بارگزاری‌رزومه',
    'introduction_file': 'بارگزاری ویدیو معرفی',
    'comment_request': 'توضیحات‌تایید‌یا‌‌رد‌درخواست',
    'rate': 'امتیاز',
    'views': 'بازدیدها',
    'visit_card': 'کارت ویزیت',
    'accepted': 'قبول',
    'rejected': 'رد',
    'new': 'جدید',
    'upload': 'بارگزاری شده',
    'password': 'رمز عبور',
    'old_password': 'رمز عبور قبلی',
    'new_password': 'رمز عبور جدید',
    'confirm_password': 'تکرار رمز عبور',
    'phone': 'شماره همراه',
    'code': 'کد تایید',
    'consultation_topic': 'موضوع مشاوره (چالش اصلی را کوتاه بنویسید)',
    'service_topic': 'موضوع خدمات (چالش اصلی را کوتاه بنویسید)',
    'service_topic_2': 'موضوع خدمات',
    'challenge': 'چالش (چالش خود را کوتاه شرح دهید)',
    'challenge_2': 'چالش',
    'consultation_commission': 'کمیسیون مشاوره',
    'consultation_vat_percentage': 'ارزش افزوده مشاوره',
    'service_commission': 'کمیسیون خدمات',
    'service_vat_percentage': 'ارزش افزوده خدمات',
    'consultation_price': 'هزینه مشاوره (ریال به ازای هر دقیقه)',
    'service_price': 'هزینه خدمات (ریال)',
    'min_service_price': 'حداقل هزینه خدمات (ریال)',
    'max_service_price': 'حداکثر هزینه خدمات (ریال)',
    'discount': 'مبلغ تخفیف (ریال)',
    'side_cost_description': 'توضیحات هزینه‌های جانبی',
    'service_day': 'دوره انجام کار (روز)',
    'min_service_day': 'حداقل دوره انجام کار (روز)',
    'max_service_day': 'حداکثر دوره انجام کار (روز)',
    'one_week_day': 'روز مورد نظر در هفته',
    'consultation': 'مشاوره',
    'service': 'خدمات',
    'service_type': 'نوع سرویس',
    'expiration_date': 'تاریخ انقضا',
    'discount_code': 'کد تخفیف',
    'discount_percentage': 'درصد تخفیف',
    'discount_value': 'حداکثر تخفیف (ریال)',
    'client_name_family': 'نام و نام خانوادگی مراجع',
    'agent_name_family': 'نام و نام خانوادگی مشاور',
    'field_branch_title': 'رشته و گرایش',
    'date': 'تاریخ',
    'consultation_start_time': 'زمان شروع مشاوره',
    'consultation_minute': 'مدت مشاوره (دقیقه)',
    'total_consultation_price': 'هزینه مشاوره (ریال)',
    'total_service_price': 'هزینه خدمت (ریال)',
    'total_price': 'جمع کل (ریال)',
    'deposit_number': 'شارژ کیف پول (ریال)',
    'withdrawal_number': 'برداشت از کیف پول (ریال)',
    'bank_accounts': 'واریز به حساب',
    'admin': 'ادمین',
    'agent': 'مباشر',
    'user': 'کاربر',
    'back_office': 'بک آفیس',
    'support': 'پشتیبان',
    'branch_document_recommended': 'مدرک پیشنهادی',
    'waiting': 'در انتظار پرداخت',
    'after_discount': 'قیمت بعد تخفیف (ریال)',
    'payment': 'پرداخت',
    'type_payment': 'مبلغ * ریال توسط کاربر پرداخت شد.',
    'start': 'ایجاد درخواست',
    'type_start': 'درخواست خدمت توسط کاربر ایجاد شد.',
    'type_file_new': 'درخواست بارگزاری فایل/فایل‌های * توسط مشاور ایجاد شد.',
    'file_new': 'مدرک جدید',
    'file_upload': 'بارگزاری مدرک',
    'type_file_upload': 'فایل/فایل‌های * توسط کاربر بارگزاری گردید.',
    'file_accepted': 'تایید مدرک',
    'type_file_accepted': 'فایل/فایل‌های * توسط مباشر تایید گردید.',
    'file_rejected': 'رد مدرک',
    'type_file_rejected': 'فایل/فایل‌های * توسط مباشر رد گردید.',
    'price': 'تعیین قیمت',
    'type_price': 'مبلغ * ریال به عنوان هزینه خدمت تعیین گردید.',
    'day': 'تعیین دوره انجام کار',
    'type_day': '* روز به عنوان دوره انجام خدمت تعیین گردید.',
    'action': 'عملیات',
    'ready_for_payment': 'در انتظار پرداخت',
    'type_ready_for_payment': 'سرویس در انتظار پرداخت قرار گرفت.',
    'type_action': '*',
    'finish': 'اتمام خدمت',
    'balance': 'موجودی کیف پول',
    'upload_file': 'بارگزاری فایل',
    'charge_amount': 'مبلغ',
    // '': '',
    // '': '',
    // '': '',
    // '': '',
    // messages
    'Create Otp': 'کد تایید ارسال شد',
    'Password Change Success': 'رمز عبور با موفقیت تغییر کرد',
    'Create City': 'شهر مورد نظر ایجاد شد',
    'City Updated': 'شهر مورد نظر به‌روزرسانی شد',
    'City Not Changed': 'شهر مورد نظر تغییری نکرد',
    'Create Province': 'استان مورد نظر ایجاد شد',
    'Province Updated': 'استان مورد نظر به‌روزرسانی شد',
    'Province Not Changed': 'استان مورد نظر تغییری نکرد',
    'Create Degree': 'مدرک تحصیلی مورد نظر ایجاد شد',
    'Degree Updated': 'مدرک تحصیلی مورد نظر به‌روزرسانی شد',
    'Degree Not Changed': 'مدرک تحصیلی مورد نظر تغییری نکرد',
    'Create Field': 'رشته مورد نظر ایجاد شد',
    'Field Updated': 'رشته مورد نظر به‌روزرسانی شد',
    'Field Not Changed': 'رشته مورد نظر تغییری نکرد',
    'Create Reservation': 'زمان مورد نظر رزرو شد',
    'Create Service': 'درخواست خدمات جدید ایجاد شد',
    'Row Updated': 'اطلاعات مورد نظر به‌روز رسانی شد'
  }

  if (word in fa) {
    return fa[word];
  } else {
    return word;
  }
};

export default Dict;